import createUseMutation from '@Modules/App/Hooks/createUseMutation';
import api from '../services/api';


const useSyncProductMutation = createUseMutation({
    mutation: storeId => api.syncProductByChannel(storeId),
});

export default useSyncProductMutation;
